import {Button, Col, Form, Row, Space, Spin, message} from "antd";
import {InputFields} from "components/common";
import React, {useEffect, useState} from "react";
import {dataFields as inputFieldsInit} from "./WordAddressAction.config";
import {employeeService} from "api";
import {
  getNPAPI,
  getWord,
} from "../../../../../../../../../redux/reducer/employee";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../../redux/hooks";
import Notification from "../../../../../../../../../components/common/notification/notification";
import dayjs from "dayjs";
import { FIELD_TYPE } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
const ModalAction = props => {
  const {data, closeModal, type, getListStore} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const employees = useAppSelector(state => state.employeesReducer);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  const [dataSource, setDataSource] = useState<any>([]);

  useEffect(() => {
    // dispatch(getWord({
    //   page: 1,
    //   limit: 1000,
    // }))
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);

  // useEffect(() => {
  //   //console.log("ádasdasd",employees.wordAddress);

  //   setOptionsWordFields(
  //       employees.wordAddress,
  //       "diaChiLamViec"
  //   );
  // }, [employees.wordAddress]);
  // const setOptionsWordFields = (list, diaChi) => {
  //   if (fieldInfo.find((field) => field.name === diaChi)) {
  //     fieldInfo.find((field) => field.name === diaChi).options = list?.map(
  //         (item) => ({
  //           value: item.diaChiLamViec,
  //           label: item.diaChiLamViec,
  //         })
  //     );
  //     setFieldInfo([...fieldInfo]);
  //   }
  // };
  const add = async () => {
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),
      };
      const res = await employeeService.createWordAddress(params);
      if(res.data.code === 400)
      {
        Notification("error", res.data.message);
      }else{
        Notification("success", "Đã thêm mới địa chỉ làm việc thành công");
      }
      setLoading(false);
      closeModal();
      await getListStore();
      form.resetFields();
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400) {
        Notification("error", error.response.data);
      } else {
        Notification("error", "Đã có lỗi khi thêm mới địa chỉ làm việc");
      }
    }
  };
  const update = async () => {
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),
        id: data.id,
      };
      const res = await employeeService.createWordAddress(params);
      setLoading(false);
      closeModal();
      Notification("success", "Đã sửa thông tin địa chỉ làm việc thành công");

      await getListStore();
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400) {
        Notification("error", error.response.data);
      } else {
        Notification("error", "Đã có lỗi khi sửa thông tin địa chỉ làm việc");
      }
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...data,
    });
  }, [data]);
  const onFinish = values => {
    if (type == "Thêm") {
      add();
    } else {
      update();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={fieldInfo}></InputFields>
            </Row>
            <Row justify="end" style={{marginTop: 20}}>
              <Col>
                <Space>
                  <Button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy
                  </Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};

export default ModalAction;
